import { useEffect, useState } from 'react';

const useModal = (modalId?:string) => {
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

	// Prevent scrolling in background when modal is open
	useEffect(() => {
		const body = document.getElementsByTagName('body')[0];
		if (isModalOpen) {
			body.classList.add(`${modalId}-modal-open`);
		} else {
			body.classList.remove(`${modalId}-modal-open`);
		}
	}, [isModalOpen]);

	const toggleModal = () => {
		setIsModalOpen(prev => !prev);
	};

	return { isModalOpen, toggleModal };
};

export default useModal;
